import { Box, Tooltip } from "@mui/material";
import { CalendarMonth as CalendarIcon } from "@mui/icons-material";
import { t } from "./coachTokens";

const PILLS = [
  { value: 0, label: "שבוע נוכחי" },
  { value: -1, label: "שבוע שעבר" },
];

// Sunday-anchored week range for a given offset (0 = current, -1 = last)
export const weekRangeLabel = (offset) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const sunday = new Date(today);
  sunday.setDate(today.getDate() - today.getDay() + offset * 7);
  const saturday = new Date(sunday);
  saturday.setDate(sunday.getDate() + 6);
  const fmt = (d) => `${d.getDate()}.${d.getMonth() + 1}`;
  return `${fmt(sunday)} — ${fmt(saturday)}`;
};

const WeekPills = ({ value, onChange }) => (
  <Box sx={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
    <Box sx={{ display: "inline-flex", gap: "5px" }}>
      {PILLS.map((p) => {
        const on = value === p.value;
        return (
          <Box
            key={p.value}
            component="button"
            onClick={() => onChange(p.value)}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              padding: "5px 11px",
              borderRadius: "20px",
              border: `1.5px solid ${on ? t.green : "transparent"}`,
              background: t.white,
              color: on ? t.green : t.t2,
              fontSize: "11.5px",
              fontWeight: on ? 700 : 500,
              cursor: "pointer",
              fontFamily: "inherit",
              whiteSpace: "nowrap",
              boxShadow: on ? "0 1px 6px rgba(1,187,167,.15)" : "none",
              transition: "all .13s",
              "&:hover": { color: t.text, borderColor: on ? t.green : t.border },
            }}
          >
            {p.label}
          </Box>
        );
      })}
    </Box>
    <Tooltip title="השבוע מחושב מיום ראשון עד שבת" arrow placement="top">
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: "5px",
          fontSize: "12px",
          color: t.text,
          fontWeight: 700,
          whiteSpace: "nowrap",
          background: t.bg,
          border: `1px solid ${t.border}`,
          borderRadius: "20px",
          padding: "4px 10px",
          cursor: "help",
        }}
      >
        <CalendarIcon sx={{ fontSize: 14, color: t.t2 }} />
        <Box component="span" sx={{ direction: "ltr" }}>{weekRangeLabel(value)}</Box>
      </Box>
    </Tooltip>
  </Box>
);

export default WeekPills;
